import React, { useEffect } from 'react';
//componets
import FlNav from './landingComponents/Navbar';
import FlFooter from './landingComponents/Footer';

//Mansory - Bento grid
import Masonry from 'react-masonry-css';

//Iconos
import icn_01 from '../../assets/img/landingPage/financial/icn_financial_01.png';
import icn_02 from '../../assets/img/landingPage/financial/icn_financial_02.png';
import icn_03 from '../../assets/img/landingPage/financial/icn_financial_03.png';
import icn_04 from '../../assets/img/landingPage/financial/icn_financial_04.png';
import icn_05 from '../../assets/img/landingPage/financial/icn_financial_05.png';
import icn_06 from '../../assets/img/landingPage/financial/icn_financial_06.png';

import icn_vision from '../../assets/img/landingPage/about/aboutUs_vision.svg';

import fondo from '../../assets/img/landingPage/fondo.png';
import ReactGA from 'react-ga4'

import Favicon from '../../assets/img/Favicon_AVAP_Framework.png'

//Importaciones de otros archivos, revisar y borrar
import gradientApi from '../../assets/img/landingPage/gradientApi.png'
import gradientServices from '../../assets/img/landingPage/gradientServices.png'

import keyfeature_01 from '../../assets/img/landingPage/financial/financial_financial_01.png'
import keyfeature_02 from '../../assets/img/landingPage/financial/financial_financial_02.png'
import keyfeature_03 from '../../assets/img/landingPage/financial/financial_financial_03.png'
import dashboard from '../../assets/img/landingPage/financial/Financial_home.png';


const Financial = () => {


    useEffect(() =>{

        if (/*config.url != 'https://avs-primary-pre.101obex.mooo.com' &&*/ true){
            ReactGA.initialize('G-08SZKPG9V0');
            ReactGA.send({ hitType: 'pageview', page: window.location.pathname, title: '101OBEX, CORP About Page' });
            }

    }, [])


    useEffect(() =>{

        if (/*config.url != 'https://avs-primary-pre.101obex.mooo.com' &&*/ true){
            ReactGA.initialize('G-08SZKPG9V0');
            ReactGA.send({ hitType: 'pageview', page: window.location.pathname, title: '101OBEX, CORP About Page' });
            }

    }, [])

    useEffect(() => {
        // favicon 
        const link = document.createElement('link');
        link.rel = 'icon';
        link.href = Favicon; // Usa la ruta importada directamente
        document.head.appendChild(link);
    
        // clean favicon 
        return () => {
          document.head.removeChild(link);
        };
      }, []);

    useEffect(() => {

        document.body.classList.add('dark-bg');
        return () => {
            document.body.classList.remove('dark-bg');
        };

    }, []);

    const productDetailsA = {
                
        Key_Feature_01: {
            title: 'Banking',
            text: "Connect channels, automate compliance, and launch new services faster. Expose legacy core systems securely as Virtual APIs, without rewriting code.",
            altDescription: "Connect channels, automate compliance, and launch new services faster. Expose legacy core systems securely as Virtual APIs, without rewriting code.",
            image: keyfeature_01,
        },
        Key_Feature_02: {
            title: "Insurance",
            text: "Unify customer, claims, and policy data across systems. AVAP Framework enables seamless experiences across brokers, apps, and third-party providers.",
            altDescription: "Unify customer, claims, and policy data across systems. AVAP Framework enables seamless experiences across brokers, apps, and third-party providers.",
            image: keyfeature_02,
        },
        Key_Feature_03: {
            title: 'Wealth & Asset Management',
            text: 
            "Deliver real-time insights and personalized engagement. Expose and orchestrate data between client platforms, advisors, and custodians with ease.",
            altDescription: 'Deliver real-time insights and personalized engagement. Expose and orchestrate data between client platforms, advisors, and custodians with ease.',
            image: keyfeature_03,
        },
    }

     //Key Benefits Bento
     const items = [
        {
          icon: icn_01,
          title: 'Unlock core systems without heavy lifting',
          paragraphs: [
            'Virtualize COBOL, AS/400, and other legacy services using AVAP’s universal wrapper, no refactoring required.',
        ]
        },
        {
          icon: icn_02,
          title: 'Accelerate product innovation',
          paragraphs: [
            'Launch new services in weeks, not months. Reuse API templates, automate governance, and simulate in isolated environments.',
          ]
        },
        {
          icon: icn_03,
          title: 'Deliver connected, personalized experiences',
          paragraphs: [
            'Unify APIs across CRM, onboarding, and payment systems to deliver frictionless omnichannel journeys.',
          ]
        },
        {
            icon: icn_04,
            title: 'Automate compliance and reporting',
            paragraphs: [
              'Leverage Gen-AI for regulatory checks, anomaly detection, and rule-based automation across your stack.',
            ]
          },
          {
            icon: icn_05,
            title: 'Scale securely and efficiently',
            paragraphs: [
              'Meet demanding SLAs with 99.99% uptime, real-time monitoring, and adaptive security, whether on-prem, cloud, or hybrid.',
            ]
          },
          {
            icon: icn_06,
            title: 'Streamline partner integrations',
            paragraphs: [
              'Connect seamlessly with fintechs, core processors, and third-party platforms using reusable, secure Virtual APIs.',
            ]
          },
    ];

    const breakpointColumnsObj = {
        default: 3, //Cambio de columnas verticales
        1100: 2,
        700: 1
      
    };

    
    return (
        <>
            <FlNav></FlNav>
            <div id="pricing"
            className="fl-cloud-product bg-black text-white"
            style={{ backgroundImage: `url(${fondo})` }}
            >
                {/* Hero Section */}
                <section id="heroProduct" className="text-center py-5">
                    <h1 className="fl-title-big m-0">AVAP for Financial Services</h1>
                    <p className="fl-title m-0 gradient-text">Secure, connected financial experiences</p>
                
                    <p className="fl-subtitle">Powered by intelligent APIs and automation <p/> <p className="fl-text fl-txt-container-s" >
                       Meet your demands for flexibility, control, and speed with <br/>AVAP Framework’s virtualization-first integration platform.
                      </p></p>
                      

                    {/*Boton Contact Us*/}  
                     <a className="glowBtn-dark" style={{zIndex: 2}} href="/contact" target='_blank'><span className="btnInner">   Contact Us  </span></a> 
                </section>
                
                {/* Subtítulo descripción */}
                <section 
                className="text-center pb-5">
                    <img
                        src={dashboard}
                        className="img-fluid mt-0 mb-4"
                        style={{ width: '70%', maxWidth: '800px', height: 'auto' }}
                    />
                     <br />
                     
                    <h2 style={{ marginTop: '160px' }} className="fl-subtitle">Unlock agility across your entire financial ecosystem</h2>
                    <p className="fl-text text-center fl-txt-container-s">
                    AVAP Framework helps banks, insurers, and asset managers modernize infrastructure, unify customer data, and automate processes, all from a single, secure control layer. With native virtualization and Gen-AI orchestration, AVAP Framework turns legacy bottlenecks into innovation-ready services.

                    </p>
                </section>
              
                {/* Sección Key Features */}
                <div className="fl-wrapper">
                    <img src={gradientServices} className="gradient gradientServices" alt="" />
                    <img src={gradientApi} alt="" className="gradient gradientlife" />
                    <p className="fl-title m-0 gradient-text pt-8 pb-6">One platform for every financial use case</p>
                     <div className="fl-container">
                        <section id="products">
                            {/*   <h3 className="fl-title text-center">Our Products & Services</h3> */}

                            <div className="fl-productsWrapper">
                                {Object.keys(productDetailsA).map((productKey, index) => (
                                    <div key={productKey} className="fl-product-item">
                                        <div className={`row align-items-center ${index % 2 === 0 ? '' : 'flex-row-reverse'}`}>
                                            <div className="col-md-6">
                                                <div className="product-content">
                                                    <h3 className="fl-subtitle">
                                                        {productDetailsA[productKey].title}
                                                    </h3>
                                                    <p className="fl-text">
                                                        {productDetailsA[productKey].text}
                                                    </p>
                                                    
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <img
                                                    src={productDetailsA[productKey].image}
                                                    alt={productDetailsA[productKey].altDescription}
                                                    className="img-fluid product-preview"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </section>
                    </div>
                </div>


                {/*MASONRY 2 COLUMNAS, ICONO CENTRADO, FONDO GRIS, TITULO Y PÁRRAFO */}
                <div className="container">
                <div className="fl-title text-center mb-5">
                    Key Benefits
                    </div>
                    <Masonry
                    breakpointCols={breakpointColumnsObj}
                    className="masonry-grid"
                    columnClassName="masonry-column"
                    >
                    {items.map((item, idx) => (
                        <div key={idx} className="fl-card-s text-center grayGradient">
                        <img src={item.icon} alt="Icon representing 0X" className="solutionsIcon" />
                        <p className="fl-subtitle-xs">{item.title}</p>
                        {item.paragraphs.map((p, i) => (
                            <p key={i} className="fl-text">{p}</p>
                        ))}
                        </div>
                    ))}
                    </Masonry>
                </div>


                {/* Sección Key Benefits */}   
               {/* <section className="container fl-z-index-2 position-relative mb-8">
                    <div className="row">
                        <div className="col  mb-5">
                            <div className="fl-title text-center mb-3">
                                Key Benefits
                            </div>
                        </div>
                    </div>
                    <div className="row ">
                        <div className="col-md-4">
                            <div className="fl-card grayGradient">
                            
                                <img
                                src={icn_vision}
                                alt="Icon representing 01."
                                className="mb-3 aboutIcon"
                                />
                                
                                <p className="fl-subtitle-xs">
                                Unlock core systems without heavy lifting
                                </p>
                                <p className="fl-text">
                                Virtualize COBOL, AS/400, and other legacy services using AVAP’s universal wrapper — no refactoring required.

                                </p>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="fl-card grayGradient">
                              
                                <img
                                src={icn_vision}
                                alt="Icon representing 01."
                                className="mb-3 aboutIcon"
                                />
                                <p className="fl-subtitle-xs">
                                 Accelerate product innovation
                                </p>
                                <p className="fl-text">
                                 Launch new services in weeks, not months. Reuse API templates, automate governance, and simulate in isolated environments.
                                    
                                </p>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="fl-card grayGradient">
                              
                                <img
                                src={icn_vision}
                                alt="Icon representing 01."
                                className="mb-3 aboutIcon"
                                />
                                <p className="fl-subtitle-xs">
                                    Deliver connected, personalized experiences
                                </p>
                                <p className="fl-text">
                                Unify APIs across CRM, onboarding, and payment systems to deliver frictionless omnichannel journeys.

                                </p>
                            </div>
                        </div>

                        <div className="col-md-4">
                            <div className="fl-card grayGradient">
                            
                                <img
                                src={icn_vision}
                                alt="Icon representing 01."
                                className="mb-3 aboutIcon"
                                />
                                <p className="fl-subtitle-xs">
                                Automate compliance and reporting
                                </p>
                                <p className="fl-text">
                                Leverage Gen-AI for regulatory checks, anomaly detection, and rule-based automation across your stack.

                                </p>
                            </div>
                        </div>

                        <div className="col-md-4">
                            <div className="fl-card grayGradient">
                               
                                <img
                                src={icn_vision}
                                alt="Icon representing 01."
                                className="mb-3 aboutIcon"
                                />
                                <p className="fl-subtitle-xs">
                                Scale securely and efficiently
                                </p>
                                <p className="fl-text">
                                Meet demanding SLAs with 99.99% uptime, real-time monitoring, and adaptive security — whether on-prem, cloud, or hybrid.

                                </p>
                            </div>
                        </div>

                    </div>
                </section>*/}

                {/* Sección built for secure */} 
                <section className="container pt-6">
                    <div className="row">
                        <div className="col">
                            <div className="blobContainer mb-4 mt-4 text-center">

                                <div className="blob"></div>
                                <div className="">
                                    <h3 className='fl-title'>Ready to modernize your financial stack?</h3>
                                    <p>Let’s talk about how AVAP Framework can help streamline operations, improve customer experiences, and drive future-ready transformation.
                                    {/*Boton Contact Us*/}  
                                    <a className="glowBtn-dark " 
                                    href="/contact" 
                                    target='_blank'><span className="btnInner">   Contact Us  </span></a> 
                                    </p>

                                </div>
                            </div>
                        </div>
                        
                    </div>
                    
                </section>

                

            </div>
            <FlFooter></FlFooter>
        </>
    );
};

export default Financial;
